<div class="container py-0">
  @if (message) {
    <div class="row justify-content-end">
      <div class="col"></div>
      @if (message.Payload.ShowYesLast) {
        <div class="col-auto pe-2 pl-0">
          <button (click)="send(false)" class="btn btn-secondary btn-round {{ message.Payload.NoCssClass }} me-n1">
            {{ message.Payload.NoLabel }}
          </button>
        </div>
        <div class="col-auto pl-2 pe-0">
          <button (click)="send(true)" class="btn btn-secondary btn-round {{ message.Payload.YesCssClass }} ms-n1">
            {{ message.Payload.YesLabel }}
          </button>
        </div>
      }
      @if (!message.Payload.ShowYesLast) {
        <div class="col-auto pe-2 pl-0">
          <button (click)="send(true)" class="btn btn-secondary btn-round {{ message.Payload.YesCssClass }} me-n1">
            {{ message.Payload.YesLabel }}
          </button>
        </div>
        <div class="col-auto pl-2 pe-0">
          <button (click)="send(false)" class="btn btn-secondary btn-round {{ message.Payload.NoCssClass }} ms-n1">
            {{ message.Payload.NoLabel }}
          </button>
        </div>
      }
    </div>
  }
</div>
